import React, { useContext, useState } from 'react'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { Controller, useForm } from 'react-hook-form'
import { Button, Checkbox, Container, FormControlLabel, Grid, Hidden, TextField, Typography } from '@mui/material';
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import RtlProvider from '../../../Components/RtlProvider';
import { ContextNotification, severitys } from '../../../App';
import colorApi from '../../../api/colorApi';
import BeatLoading from '../../../Components/Loader/BeatLoader';

const EditColor = () => {
  const { open, setOpen } = useContext(ContextNotification);
  const [submitLoading, setSubmitLoading] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const schema = yup.object().shape({
    colorName: yup.string().required("نام رنگ را وارد نمایید"),
  });
  const { register, handleSubmit, formState: { errors }, control } = useForm({
    defaultValues: async () => {
      return colorApi.GetByKey(id)
        .then(res => {
          return {
            colorName: res.data.data.colorName,
            colorCode: res.data.data.colorCode,
            planCodeKey: res.data.data.colorPlanCode,
            isActive: res.data.data.isActive,
            planCodePersian: res.data.data.planCodePersian
          }
        })
        .catch(err => console.log(err));

    },
    resolver: yupResolver(schema),
  });
  const onSubmit = (data) => {
    setSubmitLoading(true);
    const newData = {
      'id': id,
      'colorName': data.colorName,
      'colorCode': data.colorCode,
      'planCodeKey': data.planCodeKey,
      'isActive': data.isActive
    }
    colorApi.Update(newData).then((res) => {
      if (res.data.success) {
        setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.success });
        navigate("/dashboard/ColorPanel");
      }
      else {
        setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.error });
      }
    }).catch(err => {
      if (err.response) {
        setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
      }
    }
    ).finally(() => { setSubmitLoading(false); });
  };
  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
      >
        <Button variant="contained"
          component={NavLink} to={`/dashboard/ColorPanel`} color="primary" style={{ marginBottom: 10 }}>بازگشت</Button>
      </Grid>
      <Container component="main" maxWidth="xs">
        <form onSubmit={handleSubmit(onSubmit)}>
          <RtlProvider>
            <Typography component="h1" variant="h5" mb={2}>
              ویرایش رنگ
            </Typography>
            <input type="hidden" {...register("isActive")} />
            <input type="hidden" {...register("planCodeKey")} />
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField disabled id="outlined-basic" variant="outlined" {...register("planCodePersian")} fullWidth label="کد پلان" InputLabelProps={{ shrink: true }} />
              </Grid>
              <Grid item xs={12}>
                <TextField id="outlined-basic" variant="outlined" {...register("colorName")} fullWidth label="نام رنگ" InputLabelProps={{ shrink: true }} error={!!errors?.colorName}
                  helperText={errors?.colorName?.message} />
              </Grid>
              <Grid item xs={12}>
                <input type="color" {...register("colorCode")} />
              </Grid>
              <Grid item xs={12}>
                <Button type="submit" variant="contained" color="secondary" disabled={submitLoading}><BeatLoading loading={submitLoading} color={"#e65100"} size={8} />ویرایش</Button>
              </Grid>
            </Grid>
          </RtlProvider>
        </form>
      </Container>
    </>
  )
}
export default EditColor;